export default __webpack_public_path__ + "static/media/unsere_haeuser_web-xs@1x.b65aa98a.jpg";